import styles from "./HealthAndSafetyPolicyAtWorkPage.module.css";

const HealthAndSafetyPolicyAtWorkPage = () => {
  return (
    <div className={styles.container}>
      <h1>Πολιτική Υγείας και Ασφάλειας στην Εργασία</h1>
      <p>
        Βασική αρχή και δέσμευση της εταιρείας{" "}
        <strong>THE RECORDS HUB S.A.</strong> είναι η παροχή του κατάλληλου
        περιβάλλοντος εργασίας, το οποίο να εξασφαλίζει την υγεία και ασφάλεια
        των εργαζομένων της, καθώς και άλλων προσώπων που είναι πιθανό να
        επηρεασθούν από τις δραστηριότητες της εταιρείας.
      </p>

      <h2>Το πεδίο εφαρμογής της εταιρείας είναι:</h2>
      <ul>
        <li>
          Ασφαλής Ψηφιοποίηση, Φύλαξη και Διαχείριση Αρχείων των Πελατών της
          Εταιρείας, σε Έντυπη ή/και Ηλεκτρονική Μορφή
        </li>
        <li>Συμβουλευτικές Υπηρεσίες για τη Διαχείριση των Αρχείων</li>
        <li>Συμβουλευτικές Υπηρεσίες GDPR/DPO</li>
        <li>Ασφαλής Καταστροφή Αρχείων</li>
      </ul>

      <h2>Η πολιτική αυτή στηρίζεται στις πιο κάτω γενικές αρχές:</h2>
      <ul>
        <li>
          Ανάλυση του εσωτερικού και εξωτερικού περιβάλλοντος της εταιρείας για
          τα θέματα ασφάλειας και υγείας στο χώρο εργασίας.
        </li>
        <li>
          Παροχή και διατήρηση εγκαταστάσεων, συστημάτων και μεθόδων εργασίας
          που να είναι ασφαλείς και χωρίς κινδύνους για την υγεία και ασφάλεια
          των εργαζομένων.
        </li>
        <li>
          Διασφάλιση της ασφάλειας και της υγείας των εργαζομένων σε σχέση με τη
          χρήση, χειρισμό, αποθήκευση και μεταφορά αντικειμένων.
        </li>
        <li>
          Διασφάλιση της ασφάλειας και της υγείας των εργαζομένων σε σχέση με τη
          χρήση, χειρισμό, αποθήκευση και μεταφορά ουσιών.
        </li>
        <li>Παροχή των απαραίτητων πληροφοριών, οδηγιών και εκπαίδευσης.</li>
        <li>
          Προσπάθεια ελαχιστοποίησης της πιθανότητας εμφάνισης ενός κινδύνου
          αλλά και της επίπτωσής του, με την εφαρμογή κατάλληλων διαδικασιών και
          μέτρων πρόληψης και καταστολής.
        </li>
        <li>
          Συμμόρφωση με το σύνολο της εφαρμοζόμενης νομοθεσίας και εφαρμογή
          προγραμμάτων και διαδικασιών για τη διασφάλιση αυτής της συμμόρφωσης.
        </li>
        <li>Πρόληψη ατυχημάτων και επαγγελματικών ασθενειών.</li>
        <li>
          Παροχή όλων των απαιτούμενων πόρων (εκπαίδευση προσωπικού, μέσα
          ατομικής προστασίας, μέσα πυροπροστασίας) για τη διαφύλαξη της
          ασφάλειας και της υγείας των εργαζομένων.
        </li>
        <li>
          Διαβούλευση και συμμετοχή του προσωπικού στα θέματα ασφάλειας και
          υγείας στο χώρο εργασίας.
        </li>
      </ul>

      <p>
        Για να επιτύχει τα πιο πάνω, η Διεύθυνση της εταιρείας έχει σχεδιάσει,
        αναπτύξει και εφαρμόζει ένα Σύστημα για την Ασφάλεια και Υγεία, στο
        οποίο καταγράφονται η οργάνωση και οι υπευθυνότητες για την Ασφάλεια και
        Υγεία, οι Διευθετήσεις, οι Διαδικασίες, οι Κανονισμοί και οι Οδηγίες
        Εργασίας.
      </p>

      <p>
        Η Διοίκηση της εταιρείας δεσμεύεται να παρακολουθεί και να μετρά συνεχώς
        την επίδοσή της όσον αφορά τα θέματα υγείας και ασφάλειας και να
        στοχεύει στη διαρκή βελτίωση της επίδοσής της, θέτοντας στόχους. Οι
        στόχοι αυτοί καθιερώνονται και αξιολογούνται ως προς το βαθμό επίτευξής
        τους στα πλαίσια της Ανασκόπησης του Συστήματος Διαχείρισης της Υγείας
        και της Ασφάλειας στην Εργασία από τη Διοίκηση της εταιρείας.
      </p>
    </div>
  );
};

export default HealthAndSafetyPolicyAtWorkPage;
